import { toast } from 'react-toastify';
import i18n from '../../i18n';

export const toastSuccess = (message?: string) =>
  toast.success(message ? message : i18n.t('Successfully'));
export const toastError = (message?: string) =>
  toast.error(message ? message : 'Došlo je do greške');
// export const toastInfo = (message: string) => toast.info(message);
export const toastWarn = (message: string) => toast.warn(message);
